export default class CartesBancairesApiDriveService {
  path ="api/me/alias-paiement";
  constructor(httpApi) {
    this.httpApi = httpApi;
  }

  /**
   * Liste des alias paiement pour un client
   */
  async aliasPaiement(params = {}) {
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.get(this.path, config);
    return res.data;
  }

  /**
   * Renommer une carte bancaire
   * @param {String} id
   * @param {Object} data
   */
  async rename(id, data) {
    const res = await this.httpApi.put(`${this.path}/${id}`, data);
    return res.data;
  }

  /**
   * Supprimer une carte bancaire
   * @param {String} id
   */
  async delete(id) {
    const res = await this.httpApi.delete(`${this.path}/${id}`);
    return res.data;
  }
}
